module.exports = __webpack_public_path__ + "img/qrcode_2.ea52bbf9.png";